<template>
  <div>
    <div class="active-plan" v-if="planoData && !pagamentoSucesso" :class="profile && profile.company_data ? '' : 'mt-none'">
      <div class="title">
        <p>Plano atual</p>
      </div>
      <div class="plan">
        <div class="name">
          <p>{{ planoData.name }}</p>
        </div>
        <div class="value">
          <p>R$</p> <span><b>{{ planoData.price_monthly.before() }}<span>, {{ planoData.price_monthly.after() }}</span></b> / mês</span>
        </div>
        <small class="date">Data de ativação {{ date | filterDataHora }}</small>
        <a :href="plan_manage_url" target="_blank" class="plan__link" v-if="plan_manage_url !== null">
          Gerencie sua assinatura
        </a>

        <!-- Invoices (MVP) -->
        <div class="invoices" v-if="invoices && invoices.length">
          <p class="invoices__title">Faturas</p>

          <ul class="invoices__list">
            <li class="invoices__item" v-for="inv in invoices" :key="inv.id || inv.pagarme_id">
              <span class="invoices__status" :class="`--${normalizeStatus(inv.status)}`">
                {{ invoiceStatusLabel(inv.status) }}
              </span>

              <span class="invoices__id">#{{ inv.code }}</span>

              <a
                v-if="isBoleto(inv) && (inv.boleto_url || inv.boleto_pdf)"
                class="invoices__link"
                :href="inv.boleto_pdf || inv.boleto_url"
                target="_blank"
                rel="noopener"
              >
              Ver boleto
              </a>

              <span v-else class="invoices__muted">
                {{ inv.payment_method ? paymentMethodLabel(inv.payment_method) : '' }}
              </span>
            </li>
          </ul>
        </div>

      </div>
      <div class="icon">
        <img
          v-if="plan_status === 'active'"
          src="~@/assets/images/icones/active.svg"
          title="Assinatura ativa"
          v-b-tooltip.hover.right
        />
        <img
          v-else
          src="~@/assets/images/icones/inactive.svg"
          title="Gerencie sua assinatura para verificar o problema"
          v-b-tooltip.hover.top
        />
      </div>
    </div>
    <div v-else>
      <div class="plans-inner" :class="profile && profile.company_data ? '' : 'mt-none'">
        <Plans />
      </div>
    </div>
    <br />
    <p v-if="planoData && !pagamentoSucesso">
      Para tratar sobre o seu plano, atualização ou cancelamento, acesse nosso
        <a href="https://meest.tomticket.com/chat/index?id=EP71083&ac=4549312P25022026105532" target="_blank">atendimento ao cliente</a>.
      .
    </p>
    <!-- <p>
      Fazer updgrade
    </p> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import Plans from "@/components/plans/Plans.vue";
import { GetActivePlan } from "@/api/plano";
import { filterDataHora } from "@/utils/date";
export default {
  components: {
    Plans,
  },
  filters: {
    filterDataHora,
  },
  data() {
    return {
      planoData: null,
      date: "",
      plan_manage_url: null,
      plan_status: null,
      invoices: null,
    };
  },
  computed: {
    ...mapState({
      planoAtivo: state => state.plano.planoAtivo,
      pagamentoSucesso: state => state.pagamento.pagamentoSucesso,
      profile: state => state.user.dadosCompletos,
    }),
  },
  mounted() {
    this.GetActivePlan();
  },
  methods: {
    GetActivePlan,

    isBoleto(inv) {
      return (inv.payment_method || "").toLowerCase() === "boleto";
    },

    normalizeStatus(status) {
      return (status || "").toLowerCase().replace(/\s/g, "_");
    },

    invoiceStatusLabel(status) {
      const s = (status || "").toLowerCase();
      const map = {
        pending: "Fatura pendente",
        unpaid: "Fatura não paga",
        paid: "Fatura paga",
        canceled: "Fatura cancelada",
        payment_failed: "Fatura com falha",
        failed: "Fatura com falha",
        refunded: "Fatura estornada",
        generated: "Fatura gerada",
      };
      return map[s] || status || "-";
    },

    paymentMethodLabel(method) {
      const m = (method || "").toLowerCase();
      if (m === "credit_card") return "Cartão";
      if (m === "boleto") return "Boleto";
      if (m === "pix") return "Pix";
      return method;
    },
  },

  watch: {
    planoAtivo(data) {
      this.planoData = data.plan_details;
      this.plan_manage_url = data.pagarme_subscription ? data.pagarme_subscription.manage_url : null;
      this.date = data.purchase_date;

      const inv = Array.isArray(data.invoices) ? data.invoices : [];
      this.invoices = inv.sort((a, b) => {
        const da = new Date(a.due_at || a.invoice_created_at || a.created_at || 0).getTime();
        const db = new Date(b.due_at || b.invoice_created_at || b.created_at || 0).getTime();
        return db - da;
      });

      let status = ["trialing", "paid", "pending_payment", "active"];
      this.plan_status = status.includes(data.status) ? "active" : "inactive";
    },
  },

};
</script>

<style lang="scss" scoped>
.add-button {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 335px;
  width: 100%;
  height: 51px;
  border-radius: 5px;
  background-color: #41a7ff;
  cursor: pointer;

  a {
    border: none;
    color: #ffffff;
    font-size: 16px;
    font-weight: bold;
    font-family: $font__main;
    &:hover {
      color: #ffffff;
    }
  }
}

.title {
  margin-bottom: 20px;
  p {
    font-size: 22px;
    font-family: $font__main;
    font-weight: 600;
    color: #2c2c2c;
  }
}

.subtitle {
  margin-bottom: 36px;
  p {
    font-size: 16px;
    font-family: $font__main;
    font-weight: 600;
    color: #747474 !important;
  }
}

.active-plan {
  background: white;
  position: relative;
  display: flex;
  flex-direction: column;
  max-width: 438px;
  width: 100%;
  border: 3px solid #e6e6e6;
  border-radius: 10px;
  padding: 48px 52px;
  margin-right: 45px;
  margin-top: 65px;
  .title {
    margin-bottom: 36px;

    p {
      font-size: 18px;
      font-family: $font__main;
      font-weight: 600;
      color: #2c2c2c;
    }
  }
  .plan {
    &__link {
      color: #fd3064;
      display: inline-block;
      font-size: 14px;
      padding: 15px 0 0;
    }

    .name {
      margin-bottom: 12px;

      p {
        font-size: 31px;
        font-family: $font__main;
        font-weight: 600;
        color: #fd3064;
      }
    }

    .value {
      p {
        font-size: 16px;
        font-family: $font__main;
        font-weight: 600;
        color: #2c2c2c;
      }

      span {
        font-size: 24px;
        font-family: $font__main;
        font-weight: 600;
        color: #2c2c2c;
      }

      span b {
        font-size: 108px;
        font-family: $font__main;
        font-weight: 600;
        color: #2c2c2c;
        line-height: 108px;
      }
    }
    .date {
      font-size: 12px;
      margin-top: 15px;
      color: #747474;
      display: inline-block;
    }
  }

  .icon {
    position: absolute;
    top: 17px;
    right: 17px;
  }
}

.invoices {
  margin-top: 14px;

  &__title {
    font-size: 13px;
    font-weight: 600;
    color: #2c2c2c;
    margin: 10px 0 8px;
  }

  &__list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  &__item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 6px 0;
  }

  &__id {
    font-size: 12px;
    font-weight: 500;
    color: #2c2c2c;
    // margin: 10px 0 8px;
  }

  &__status {
    font-size: 12px;
    font-weight: 600;
    padding: 4px 8px;
    border-radius: 999px;
    background: #f2f2f2;
    color: #2c2c2c;

    &.--paid { background: rgba(0, 180, 90, 0.12); }
    &.--pending { background: rgba(255, 165, 0, 0.14); }
    &.--unpaid,
    &.--payment_failed,
    &.--failed { background: rgba(255, 0, 0, 0.10); }
    &.--canceled { background: rgba(0, 0, 0, 0.08); }
  }

  &__link {
    font-size: 12px;
    color: #fd3064;
    text-decoration: underline;
  }

  &__muted {
    font-size: 12px;
    color: #747474;
  }
}


.plans-inner {
  position: relative;
  display: flex;
  width: 100%;
  background-color: white;
  border-radius: 10px;
  padding: 18px;
  margin-top: 65px;
  .plans {
    display: flex;
  }
}

@media only screen and (max-width: 1725px) {
  .active-plan {
    max-width: 360px;
    padding: 36px 39px;

    .plan {
      .name {
        p {
          font-size: 28px;
        }
      }

      .value {
        span b {
          font-size: 75px;
          line-height: 75px;
        }
      }
    }
  }
}

@media only screen and (max-width: 1550px) {
  .active-plan {
    max-width: 320px;
    margin-right: 20px;
    padding: 24px 26px;

    .plan {
      .name {
        p {
          font-size: 20px;
        }
      }

      .value {
        p {
          font-size: 14px;
        }

        span {
          font-size: 22px;
        }

        span b {
          font-size: 50px;
          line-height: 50px;
        }
      }
    }
  }
}

@media only screen and (max-width: 1300px) {
  .active-plan {
    .title {
      p {
        font-size: 14px;
      }
    }

    .plan {
      .name {
        p {
          font-size: 13px;
        }
      }

      .value {
        p {
          font-size: 14px;
        }

        span {
          font-size: 14px;
        }

        span b {
          font-size: 35px;
          line-height: 35px;
        }
      }
    }

    .icon {
      img {
        width: 20px;
      }
    }
  }
}
</style>
